import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Llegás al box sin saber exactamente qué WOD vas a programar esta semana', 'Tus alumnos no progresan porque no tenés una estructura clara de sesión en sesión', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 WODs de siempre porque no tenés más material listo', 'No podés justificar cobrar más porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas en técnica olímpica, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles juntos y la clase se convierte en un caos de escalados', 'Fin de mes y los alumnos se van sin avisar porque no tenés un sistema de seguimiento'];
export function PainPoints() {
  return <section className="py-12 md:py-20 px-4 bg-cf-darker border-t border-white/10" data-id="element-270">
      <div className="max-w-4xl mx-auto" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-272">
          <h2 className="text-lg md:text-3xl text-gray-300 font-medium mb-4" data-id="element-273">
            Si sos instructor/a de Crossfit en Argentina, esto te va a sonar
            familiar:
          </h2>
        </motion.div>

        <div className="space-y-2.5 md:space-y-4 mb-10 md:mb-16" data-id="element-274">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3 md:gap-4 bg-cf-card p-3 md:p-5 rounded border border-cf-red/20" data-id="element-275">
              <div className="bg-cf-red/10 p-1 rounded shrink-0 mt-0.5" data-id="element-276">
                <X className="w-4 h-4 md:w-5 md:h-5 text-cf-red" data-id="element-277" />
              </div>
              <p className="text-sm md:text-lg text-gray-200" data-id="element-278">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-279">
          <h3 className="font-bebas text-3xl md:text-7xl text-cf-red tracking-tight leading-tight" data-id="element-280">
            ¿CUÁNTAS CLASES MÁS VAS A IMPROVISAR?
          </h3>
        </motion.div>
      </div>
    </section>;
}